import { StringBase } from '../StringBase';

export class Counties extends StringBase {}
